import { useToast } from '@chakra-ui/react';
import {
  useCreateBuyerOfferAnalysisMutation,
  useListingforMlsListingLazyQuery,
} from '@client/graphql/__generated__/main-operations';

interface CreateBuyerOfferAnalysisProps {
  mlsListingId?: string;
  partyId?: string;
  listingId?: string;
}

export const useCreateBuyerOfferAnalysis = () => {
  const toast = useToast();
  const [createBuyerOfferAnalysis, { loading }] =
    useCreateBuyerOfferAnalysisMutation();
  const [listingForMlsListing, { loading: loadingListing }] =
    useListingforMlsListingLazyQuery();

  const getSelectedListingId = async (mlsListingId: string) => {
    const { data } = await listingForMlsListing({
      variables: {
        input: {
          id: mlsListingId,
        },
      },
    });

    if (data?.syncListingFromMLS) {
      return data.syncListingFromMLS.id;
    }
  };

  const handleCreate = async ({
    mlsListingId,
    partyId,
    listingId,
  }: CreateBuyerOfferAnalysisProps) => {
    if (!mlsListingId && !listingId) {
      return;
    }

    let listingIdToUse = listingId;

    if (!listingId && mlsListingId) {
      listingIdToUse = await getSelectedListingId(mlsListingId);
    }

    if (!listingIdToUse) {
      toast({
        title: 'Error creating offer scorecard',
        description: 'Failed to create the offer scorecard. Please try again.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });

      return;
    }

    const { data } = await createBuyerOfferAnalysis({
      variables: {
        input: {
          listingId: listingIdToUse,
          partyId: partyId,
        },
      },
    });

    if (!data?.createBuyerOfferAnalysis) {
      toast({
        title: 'Error creating offer scorecard',
        description: 'Failed to create the offer scorecard. Please try again.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });

      return;
    }

    return data.createBuyerOfferAnalysis;
  };

  return { handleCreate, loading: loading || loadingListing };
};
